export default __webpack_public_path__ + "static/media/user-icon.23bb0315.svg";